/**
 * @description Component-TradeHistoryDrawerHeader
 */
import './index.less';

import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import IconBack from '@/assets/svg/icon_chevron_left.svg?react';
import IconRefresh from '@/assets/svg/icon_refresh_linear.svg?react';
import { Button } from '@/components/Button';
interface IPropTypes {
  className?: string;
  onClose: () => void;
  onRefresh: () => void;
}
const HistoryDrawerHeader: FC<IPropTypes> = function ({ onClose, onRefresh }) {
  const { t } = useTranslation();

  return (
    <div className="syn-history-drawer-header">
      <div className="syn-history-drawer-header-left">
        <Button type="text" icon={<IconBack className="icon" />} onClick={onClose} />
        <span>{t('common.history')}</span>
      </div>

      <Button autoFocus type="text" icon={<IconRefresh className="icon" />} onClick={onRefresh} />
    </div>
  );
};

export default HistoryDrawerHeader;
